import { Citation } from '#/api'
import { CommandBarButton } from '@fluentui/react'
import styles from './TrafoChatReferenceItem.module.css'
import { useCallback, useMemo } from 'react'
import { convertCitationToChips } from './citationToChips'
import { decodeUnicode } from './utils'

type TrafoChatReferenceItemProps = {
  citation: Citation
  onTitleClick: (citation: Citation) => void
  onShowClick: (citation: Citation) => void
}

export const TrafoChatReferenceItem = ({ citation, onTitleClick, onShowClick }: TrafoChatReferenceItemProps) => {
  const handleTitleClick = useCallback(() => {
    onTitleClick(citation)
  }, [citation])

  const handleShowClick = useCallback(() => {
    onShowClick(citation)
  }, [citation])

  const title = useMemo(() => {
    return decodeUnicode(citation.title?.replaceAll('_', ' '))
  }, [citation.title])

  const subTitle = useMemo(() => {
    return citation.section
  }, [citation.chunk_id])

  const chips = useMemo(() => {
    return convertCitationToChips(citation)
  }, [citation])

  const referenceIndex = useMemo(() => {
    return `${citation.reference?.replace(/[^a-zA-Z0-9]/g, '')}.`
  }, [citation.reference])

  const showSubTitle = subTitle && subTitle !== '' ? true : false
  const showChips = chips.length > 0

  return (
    <div className={styles.referenceItemMainContainer}>
      <div className={styles.referenceItemContentContainer}>
        <div className={styles.referenceItemTitle} onClick={handleTitleClick}>
          {referenceIndex} {title}
        </div>
        {showSubTitle && <div className={styles.referenceItemSubTitle}>{subTitle}</div>}
        {showChips && (
          <div>
            {chips.map(chip => (
              <span
                key={chip.id}
                className={styles.referenceItemChip}
                aria-label={chip.hintValueDisplay}
                title={chip.hintValueDisplay}>
                {chip.displayValue}
              </span>
            ))}
          </div>
        )}
      </div>
      <div className={styles.referenceItemDownloadContainer}>
        <CommandBarButton
          role="button"
          className={styles.referenceItemShowButton}
          iconProps={{ iconName: 'RedEye' }}
          onClick={handleShowClick}
          aria-label="display document"
        />
      </div>
    </div>
  )
}
